@if (isLoading()) {
  <div class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Caricamento tavolo...</span>
    </div>
  </div>
} @else if (initialData()) {
  <app-game-table-form
    title="Modifica tavolo"
    submitLabel="Salva Modifiche"
    [initialData]="initialData()!"
    [availableEvents]="availableEvents()"
    [availableOrganizations]="availableOrganizations()"
    (formSubmit)="onSubmit($event)"
    (cancel)="onCancel()">
  </app-game-table-form>
}
